import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation } from '@tanstack/react-query';
import { useMemo } from 'react';
import { WalletAccountingSyncApiAdapter } from '../adapters';
import type { AccountingSyncStatus } from '../models';

export interface ExportAccountingSyncParams {
  status?: AccountingSyncStatus;
}

export const useWalletAccountingSyncExport = () => {
  const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
  const adapter = useMemo(() => new WalletAccountingSyncApiAdapter(httpClient), [httpClient]);

  return useMutation({
    mutationFn: (params: ExportAccountingSyncParams) => adapter.downloadCsv(params),
  });
};
